import omit from "lodash/omit";

export const modifyDocumentTitle = (item: string) =>
  (document.title = `${item} | Combined Arms Slotting`);

const formatDownloadOutput = (download) => {
  download.event.event_reserves = [];
  const stringified = JSON.stringify(
    omit(download, [
      "loading",
      "error",
      "numTimesRequested",
      "editors",
      "filled_slots",
      "total_slots",
    ])
  );
  return stringified
    .replace(/"player_id":"\d*"/gm, `"player_id":""`)
    .replace(/"player_name":".*?"/gm, `"player_name":""`)
    .replace(/children/gm, "child");
};

export const downloadMissionSchema = ({ currentEvent, eventTitle }) => {
  const element = document.createElement("a");
  const file = new Blob([formatDownloadOutput(currentEvent)], {
    type: "text/plain",
  });
  element.href = URL.createObjectURL(file);
  element.download = `${eventTitle}_schema.json`;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
};
